import { TsDOM as q } from '@/scripts/core/TsDOM'
import { LongevityScoreHero } from '@/scripts/sections/longevity-score-hero'

q.safeDefineElement(LongevityScoreHero)
